import { Box } from '@material-ui/core'
import React, { useEffect } from 'react'
import Amount from '../../../../components/common/Amount'
import ButtonCustom from '../../../../components/common/ButtonCustom'
import Card from '../../../../components/common/Card'
import { useStyles } from './RightCheckout.style'
import { t } from 'i18next'
import i18n from '../../../language/localization'
import { useSelector } from 'react-redux'
import { getFormatCurrency } from 'utils/helper'
import { getCostCentersByUser } from 'api/authorization'

const RightCheckout = props => {
  const { isBank, webThemeColor, loadingBtn } = props
  const classes = useStyles()

  const { checkoutCartItem, isCheckout } = useSelector(state => state.cart)
  const [uniqueCode] = React.useState()
  const [uniqueCodeStatus] = React.useState()
  const [costCenterList, setCostCenterList] = React.useState([])
  const [loadingCostCenter, setLoadingCostCenter] = React.useState(false)
  const [costCenterId, setCostCenterId] = React.useState()

  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem('userdata'))
    } catch (error) {
      return null
    }
  })()
  const department = (() => {
    try {
      return JSON.parse(localStorage.getItem('department'))
    } catch (error) {
      return null
    }
  })()
  const OrderDetail = checkoutCartItem.filter(item => item.order_cart_item.checked_out)

  const handleGetCostCenter = async () => {
    if (!user.email) return
    setLoadingCostCenter(true)
    try {
      const response = await getCostCentersByUser(user.email)
      if (!response.success) {
        return
      }

      setCostCenterList(response.data)

      if (response.data.length === 1) {
        setCostCenterId(response.data[0].cost_center.id)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingCostCenter(false)
    }
  }

  const totalItem = OrderDetail.map(cart => {
    return cart.order_cart_item.quantity
  })

  const totalWeight = OrderDetail.map(cart => {
    return cart.product.weight * cart.order_cart_item.quantity
  })

  const totalPrice = OrderDetail.map(cart => {
    return cart.order_cart_item.price * cart.order_cart_item.quantity
  })

  const listData = [
    {
      lable: `${t('Total items')}`,
      value: `${totalItem.reduce((prev, next) => prev + next, 0)} Pcs`
    },
    {
      lable: `${t('Total order')}`,
      value: <Amount amount={totalPrice.reduce((prev, next) => prev + next, 0)} />,
      valueText: 'Rp'
    },
    {
      lable: isBank ? (uniqueCodeStatus == 1 ? `${t('Unique Code')}` : null) : null,
      value: isBank ? (
        uniqueCodeStatus == 1 ? (
          <Amount amount={parseInt(uniqueCode)} />
        ) : null
      ) : null,
      valueText: isBank ? (uniqueCodeStatus == 1 ? 'Rp' : null) : null
    }
  ]

  const listData2 = [
    {
      lable: `${t('Total items')}`,
      value: `${totalItem.reduce((prev, next) => prev + next, 0)} Pcs`
    },
    {
      lable: `${t('Total weight')}`,
      value: `${getFormatCurrency(totalWeight.reduce((prev, next) => prev + next, 0))} Gram`
    },
    {
      lable: `${t('Total order')}`,
      value: <Amount amount={totalPrice.reduce((prev, next) => prev + next, 0)} />,
      valueText: 'Rp'
    },
    {
      lable: <label style={{ fontWeight: '600' }}>{t('grand_total')}</label>,
      value: (
        <Amount amount={OrderDetail ? props.grandTotal : null} style={{ fontWeight: '600' }} />
      ),
      valueText: <label style={{ fontWeight: '600' }}>Rp</label>
    }
  ]

  const ListItem = props => {
    return (
      <Box className={classes.listStyle}>
        <h4 className='lable'>{props.lable}</h4>
        <div className={classes.valueText}>
          <h4 className='lable'>{props.valueText}</h4>
          {props.children ?? <h4 className='lable'>{props.value}</h4>}
        </div>
      </Box>
    )
  }

  const handlePlaceOrder = () => {
    props.PlaceOrderClick({ departmentId: department.id, costCenterId })
  }

  useEffect(() => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    i18n.changeLanguage(JSON.parse(localStorage.getItem('Language')))
    handleGetCostCenter()
  }, [])

  return (
    <Card className={classes.cardStyle}>
      <header>
        <label className='heading'>Order Summary</label>
      </header>
      <Box className='cardContent'>
        <Box className='listItems'>
          <ListItem lable='Departement' value={department?.name} />
          <ListItem lable='Cost Center'>
            <select
              id='costCenter'
              name='costCenter'
              onChange={e => setCostCenterId(e.target.value)}
              value={costCenterId}
            >
              <option>{loadingCostCenter ? 'Loading...' : '-- Choose one --'}</option>
              {costCenterList.map(costCenter => (
                <option
                  key={costCenter.cost_center.id}
                  selected={costCenter.cost_center.id === costCenterId}
                  value={costCenter.cost_center.id}
                >
                  {costCenter.cost_center.name}
                </option>
              ))}
            </select>
          </ListItem>
          {isCheckout
            ? listData.map(data =>
                (() => {
                  if (data.lable) {
                    return (
                      <ListItem
                        key={data.value}
                        lable={data.lable}
                        valueText={data.valueText}
                        value={data.value}
                      />
                    )
                  }
                  return null
                })()
              )
            : listData2.map(data =>
                (() => {
                  if (data.lable) {
                    return (
                      <ListItem lable={data.lable} valueText={data.valueText} value={data.value} />
                    )
                  }
                  return null
                })()
              )}
        </Box>
        {isCheckout ? (
          <ButtonCustom
            disabled={!costCenterId}
            bg={webThemeColor}
            width='full'
            className={classes.btn_fullwidth11}
            onClick={handlePlaceOrder}
          >
            Submit PO
            {loadingBtn ? null : null}
          </ButtonCustom>
        ) : (
          <ButtonCustom
            disabled={!costCenterId}
            bg={webThemeColor}
            width='full'
            className={classes.btn_fullwidth11}
            onClick={props.PlaceOrderClickPayonspot}
          >
            Place To Order
            {loadingBtn ? null : null}
          </ButtonCustom>
        )}
        {/* <p className='side-terms'>
          Upon clicking {`"Place Order"`}, I confirm I have read and Acknowledge all
          <u> terms and policies.</u>
        </p> */}
      </Box>
    </Card>
  )
}

export default RightCheckout
